// extracted by mini-css-extract-plugin
export default {"container":"drawer-body_container__t0Hcy","faq-menu-option":"drawer-body_faq-menu-option__XcLHD"};